module.exports = __webpack_public_path__ + "img/geod_11.47277b44.jpg";